var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPopup = function SvgPopup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 16.05a2.925 2.925 0 0 0 2.925-2.925v-7.2A2.925 2.925 0 0 0 13.125 3h-7.2A2.925 2.925 0 0 0 3 5.925v7.2a2.925 2.925 0 0 0 2.925 2.925h7.2Zm-5.175.9H9.3v1.125c0 .87.705 1.575 1.575 1.575h7.2c.87 0 1.575-.705 1.575-1.575v-7.2c0-.87-.705-1.575-1.575-1.575H16.95V7.95h1.125A2.925 2.925 0 0 1 21 10.875v7.2A2.925 2.925 0 0 1 18.075 21h-7.2a2.925 2.925 0 0 1-2.925-2.925V16.95Z",
    fill: "#666"
  })));
};
export default SvgPopup;